import React, { Component, PropTypes } from 'react';
import { flow } from "lodash";
import { DragSource, DropTarget } from 'react-dnd';
import { findDOMNode } from 'react-dom';
import { getMapServerParams, readLayerBounds } from '../../businessLogic/map';

class SelectedLayer extends Component {
	zoom2layer(layer) {

		this.props.getMapLayerCapabilities(layer, (json, xmlDoc) => {
			const bounds = readLayerBounds(json, xmlDoc);
			// GOOGLE MAP ZOOM TO LAYER
			this.props.zoomToLayer(bounds);
		});

	}

	isMoreThanOneProjectSelected() {
		const { layers } = this.props;

		let projetosSelecionados = new Set();
		layers.map((l) => projetosSelecionados.add(l.projeto));

		return projetosSelecionados.size > 1;
	}

	projetoIndicator() {
		const { layer } = this.props;

		if (this.isMoreThanOneProjectSelected()) {
			const projetoClass = 'projeto ' + getMapServerParams(layer).projeto;
			return (
				<div className={projetoClass}>
					{getMapServerParams(layer).projeto}
				</div>
			);
		}
	}

	render() {
		const { layer, isDragging, connectDragSource, connectDropTarget, removeLayer } = this.props;
		const opacity = isDragging ? 0 : 1;
		const style = {
			border: '1px dashed gray',
			padding: '0.5rem 0rem',
			marginBottom: '.5rem',
			backgroundColor: 'white',
			marginTop: '5px',
			cursor: 'move'
		};

		if (!this.isMoreThanOneProjectSelected()) {
			style.marginLeft = '0';
		}

		return connectDragSource(connectDropTarget(
			<div className="row boxCamada" style={{ ...style, opacity }}>

				{this.projetoIndicator()}

				<div className="lupa">
					<span style={{}}>
						<i className="fas fa-search-location pointer"
						onClick={() => this.zoom2layer(layer)}
						data-tip="zoom na layer" />
					</span>
				</div>

				<div className="nome" >
					<span >
						{getMapServerParams(layer).name}
						{' '}
					</span>
				</div>
				<div className="remover" style={{marginRight: '-10px'}}>
					<span className="">
						<i className="fas fa-times pointer" 
						onClick={() => removeLayer(layer.id)} 
						data-tip="Remover Camada" />
					</span>

				</div>

			</div>
		));
	}

}

SelectedLayer.propTypes = {
	connectDragSource: PropTypes.func.isRequired,
	connectDropTarget: PropTypes.func.isRequired,
	index: PropTypes.number.isRequired,
	isDragging: PropTypes.bool.isRequired,
	layers: PropTypes.array.isRequired,
	layer: PropTypes.object.isRequired,
	removeLayer: PropTypes.func.isRequired,
	moveLayer: PropTypes.func.isRequired,
	zoomToLayer: PropTypes.func.isRequired,
	getMapLayerCapabilities: PropTypes.func.isRequired
};

const layerSource = {
	beginDrag(props) {
		return { index: props.index };
	}
};

const layerTarget = {
	hover(props, monitor, component) {
		const dragIndex = monitor.getItem().index;
		const hoverIndex = props.index;

		// Don't replace items with themselves
		if ( dragIndex === hoverIndex ) return;

		// Determine rectangle on screen
		const hoverBoundingRect = findDOMNode(component).getBoundingClientRect();

		// Get vertical middle
		const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;

		// Determine mouse position
		const clientOffset = monitor.getClientOffset();

		// Get pixels to the top
		const hoverClientY = clientOffset.y - hoverBoundingRect.top;

		// Only perform the move when the mouse has crossed half of the items height
		// When dragging downwards, only move when the cursor is below 50%
		// When dragging upwards, only move when the cursor is above 50%

		// Dragging downwards
		if ( dragIndex < hoverIndex && hoverClientY < hoverMiddleY ) return;

		// Dragging upwards
		if ( dragIndex > hoverIndex && hoverClientY > hoverMiddleY ) return;

		// Time to actually perform the action
		props.moveLayer(dragIndex, hoverIndex, props.layers[dragIndex]);

		// Note: we're mutating the monitor item here!
		// Generally it's better to avoid mutations,
		// but it's good here for the sake of performance
		// to avoid expensive index searches.
		monitor.getItem().index = hoverIndex;
	}
};

export default flow(
	DropTarget("LAYER", layerTarget, connect => ({
		connectDropTarget: connect.dropTarget()
	})),
	DragSource("LAYER", layerSource, (connect, monitor) => ({
		connectDragSource: connect.dragSource(),
		isDragging: monitor.isDragging()
	}))
)(SelectedLayer);


// WEBPACK FOOTER //
// ./src/components/Explorer/SelectedLayer.js